import { VariaveisAmbiente } from 'config';
import { ParametroSistemaModel } from 'model/api/gestao/parametro-sistema/parametro-sistema-model';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';

export function usePostAdicionarParametroSistema() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const postAdicionarParametroSistema = useCallback(
        (sistemaId: string, parametro: ParametroSistemaModel) =>
            invocarApi({
                url: `/${VariaveisAmbiente.apiVersion}/sistema/${sistemaId}/parametro`,
                method: 'POST',
                data: parametro,
                enviarTokenUsuario: true
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        postAdicionarParametroSistema,
    };
}
